const reducerScheduledServices = {
  completed: 'Servicios Completados',
  delayed: 'Servicios Retrasados',
  scheduledServices: 'Servicios Programados',
};

export default reducerScheduledServices;
